import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {get_Chat_analyzises,get_UserData,get_AstroData,get_Chat_message_history} from "../../../store/actions/CommanAction";  
import DataTable from "react-data-table-component";
import { Button, Dropdown, Modal, Nav, Tab } from "react-bootstrap";
import Loader from "../Loader/Loader";
import { customStyles } from "../Utility/Utility";

const CallHistoryAnalysis = () => {
  const dispatch = useDispatch();
  const ChatFilter = useSelector((state) => state.feedBackReducer.GetDataChatAnalyses);
 
  const totalAmt = ChatFilter?.reduce((sum, item) => sum + (item.Amt || 0), 0);
  const userData = useSelector((state) => state.feedBackReducer.UserData);
  const AstroData = useSelector((state) => state.feedBackReducer.AstroData);
  const singlechatmessage = useSelector(
    (state) => state.feedBackReducer.GetChatMessagehistory
  );

  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [loading, setloading] = useState(false);
  const [UserData, setUserData] = useState([]);
  const [astrosdata, setAstrosdata] = useState([]);
  const [messages, setMessages] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedChat, setSelectedChat] = useState(null);
  const[chatData,setChatData]=useState([]);



  useEffect(()=>{
if(!selectedChat)
{
 
    setChatData(ChatFilter)
}
 },[ChatFilter,get_Chat_analyzises,startTime,endTime,AstroData,userData])


 
  
  const [astroName, setAstroName] = useState("");
  const [astroMobileNo, setAstroMobileNo] = useState("");
  const [userName, setUserName] = useState("");
  const [userMobileNo, setUserMobileNo] = useState("");
   const [timeoutId, setTimeoutId] = useState(null);

  useEffect(() => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    const formattedToday = `${yyyy}-${mm}-${dd}`;

    const defaultStartTime = `${formattedToday}`;
    const defaultEndTime = `${formattedToday}`;

    setStartTime(defaultStartTime);
    setEndTime(defaultEndTime);

  
     dispatch(get_Chat_analyzises(null,null,null,formattedToday,formattedToday,astroName,userName,userMobileNo,astroMobileNo,setloading)
    );
  }, [dispatch]);

  useEffect(() => {
    dispatch(get_UserData(setloading, isActive));
    dispatch(get_AstroData(isActive));
  }, []);

  useEffect(() => {
    const formattedMessages = singlechatmessage?.map((item) => ({
      sender: item?.IsfromAstro ? "astrologer" : "user",
      text: item?.Message,
    }));
    setMessages(formattedMessages);
  }, [singlechatmessage]);

  useEffect(() => {
    if (userData && Array.isArray(userData)) {
      const filtered = userData.map(({ NickName, UserID }) => ({
        label: NickName,
        value: UserID,
      }));
      setUserData(filtered);
    }
  }, [userData]);
  useEffect(() => {
    if (AstroData && Array.isArray(AstroData)) {
      const filtered = AstroData.map(({ DisplayName, ID }) => ({
        label: DisplayName,
        value: ID,
      }));
      setAstrosdata(filtered);
    }
  }, [AstroData]);

  const handleEditClick = (row) => {
    setSelectedChat(row);
    dispatch(get_Chat_analyzises(row.AstroId, row.UserID
, row.ChatId, null, null, null, null, null, null, setloading));
dispatch(get_Chat_message_history(row.AstroId, row.UserID, row.ChatId, setloading))
    setShowModal(true);
  };

 useEffect(() => {
    if (
      astroName.length < 3 &&
      userMobileNo.length < 3 &&
      userName.length < 3 &&
      astroMobileNo.length < 3
    )
      return;

    if (timeoutId) clearTimeout(timeoutId);

    const newTimeoutId = setTimeout(() => {
      setloading(true);
      dispatch(get_Chat_analyzises(null,null,null,startTime,endTime,astroName,userName,userMobileNo,astroMobileNo,setloading));
      setloading(false);
    }, 500);

    setTimeoutId(newTimeoutId);

    return () => clearTimeout(newTimeoutId);
  }, [astroName, userMobileNo, userName, astroMobileNo]);


  const handleSearch = () => {
    if (startTime ) {
      const formatDate = (dateTime) => {
        if (!dateTime) return null;
        const date = new Date(dateTime);
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
      };

      const formattedStartDate = formatDate(startTime);
      const formattedEndDate = formatDate(endTime);

      const data = {
        FromDate: formattedStartDate,
        Todate: formattedEndDate,
      };

        dispatch(get_Chat_analyzises(null,null,null,formattedStartDate,formattedEndDate,astroName,userName,userMobileNo,astroMobileNo,setloading));
     ;
    } else {
      alert("Please select both Start Time and End Time");
    }
  };
  const handleReset = () => {
    const today = new Date().toISOString().split("T")[0];

    setStartTime("");
    setEndTime("");
    setAstroName("");
    setUserName("");
    setUserMobileNo("");
    setAstroMobileNo("");
   
  };

  const columns = [
    {
      name: "Astrologer Name",
      selector: (row) => row.AstroName,
      sortable: true,
       cell: (row) => (
        <div>
          <div>{row.AstroName}({row.AstroId})</div>
           <div style={{ fontSize: "12px", color: "#0b0e11ff" }}>
        {row.AstroMobileNo}
      </div>
        </div>
      ),
    },
    
    {
      name: "User Name",
      selector: (row) => row.UserName,
      sortable: true,
      cell: (row) => (
        <div>
          <div>{row.UserName}({row.UserID})</div>
           <div style={{ fontSize: "12px", color: "#0b0e11ff" }}>
        {row.UserMobileNo}
      </div>
        </div>
      ),
    },
   
    {
      name: "Type",
      selector: (row) => row.Type,
      sortable: true,
    },
    {
      name: "Interest",
      selector: (row) => row.DetectedInterest,
      sortable: true,
    },
   
    {
      name: "Date",
      selector: (row) => {
        const date = new Date(row.Date);
        return date.toLocaleString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false, 
        });
      },
      sortable: true,
      width: "200px",
    },
    

    {
      name: (
        <p
          className="text-end"
          style={{ position: "absolute", top: "7px", right: 50 }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <div style={{ position: "absolute", top: 4, right: 50 }}>
          <Dropdown>
            <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Dropdown.Toggle>
            <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
              <Dropdown.Item onClick={() => handleEditClick(row)}>
                Show History
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
    },
  ];


 const recommendedActions = selectedChat?.RecommendedActions
    ? JSON.parse(selectedChat.RecommendedActions)
    : [];

  const violationContent = selectedChat?.ViolationContent
    ? JSON.parse(selectedChat.ViolationContent)
    : [];





  return (
    <div>
      <div className="form-group  main_card">
      <h2 style={{ color: '#f7931e', fontWeight: 700 }}>Chat History Analyze</h2>
        <div className="row mt-3">
          <div className="col-3">
            <label className="form-label">Start Time</label>
            <input
              type="date"
              
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
            />
          </div>
          <div className="col-3">
            <label className="form-label">End Time</label>
            <input
              type="date"
           
              value={endTime}
              onChange={(e) => setEndTime(e.target.value)}
            />
          </div>
        </div>
       
        <div className="row mt-3 ">
          
           <div className="col-3">
            <label className="form-label">Astrologer Name</label>
            <input
              type="text"
            
              value={astroName}
              placeholder="Enter Astrologer name"
              onChange={(e) => {
                const input = e.target.value;
                if (/^[A-Za-z\s]{0,50}$/.test(input)) {
                  setAstroName(input);
                }
              }}
            />
            {astroName.length > 0 && astroName.length < 3 && (
              <span className="text-danger">
                Name must be at least 3 characters
              </span>
            )}
          </div>

          <div className="col-3">
            <label className="form-label">User Name</label>
            <input
              type="text"
            
              value={userName}
              placeholder="Enter User name"
              onChange={(e) => {
                const input = e.target.value;
                if (/^[A-Za-z\s]{0,50}$/.test(input)) {
                  setUserName(input);
                }
              }}
            />
            {userName.length > 0 && astroName.length < 3 && (
              <span className="text-danger">
                Name must be at least 3 characters
              </span>
            )}
          </div>

          <div className="col-auto">
            <button className="btn btn-primary ms-2 mt-3" onClick={handleSearch}>
              Search
            </button>
            <button className="btn btn-secondary  ms-2 mt-3" onClick={handleReset}>
          Reset
        </button>
          </div>
        </div>
      </div>

 <Modal show={showModal} onHide={() => setShowModal(false)} centered size="xl">
      <Modal.Header closeButton>
        <Modal.Title style={{ width: "100%", textAlign: "center" }}>
          Chat History & Violations
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: "75vh", overflow: "hidden" }}>
        {loading ? (
          <Loader />
        ) : (
          <>
     
            {selectedChat && (
              <div style={{backgroundColor:"#d8801cff" ,color:"black"}} className="mb-3 p-3 rounded shadow-sm ">
                <p className="mb-1">
                  <strong style={{ color: "black" }}>Astrologer:</strong>{" "}
                  {selectedChat.AstroName}    📞 {selectedChat.AstroMobileNo}<br />
                  <small style={{ color: "#f8f4f4ff" }}>
                   
                  </small>
                   <strong style={{ color: "black" }}>User:</strong>{" "}
                  {selectedChat.UserName}    📞 {selectedChat.UserMobileNo} <br />
                 
                </p>
               
              </div>
            )}

          
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "15px",
                height: "calc(75vh - 160px)",
              }}
            >
             
              <div
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  background: "#f8f8f8",
                  padding: "10px",
                  overflowY: "auto",
                }}
              >
                <h5 className="text-primary mb-3">Conversation</h5>
               {messages?.length > 0 ? (
  messages.map((msg, index) => (
    <div
      key={index}
      style={{
        display: "flex",
        justifyContent:
          msg.sender === "astrologer" ? "flex-start" : "flex-end",
        marginBottom: "8px",
      }}
    >
      <div
        className={`chat-message ${
          msg.sender === "astrologer" ? "astro-message" : "user-message"
        }`}
        style={{
          background:
            msg.sender === "astrologer" ? "#e0f2fe" : "#ede9fe",
          padding: "8px 12px",
          borderRadius: "12px",
          maxWidth: "75%",
          textAlign: "left",
          boxShadow: "0px 1px 2px rgba(0,0,0,0.1)",
        }}
      >
        <strong style={{ display: "block", fontSize: "0.85rem", color: "#555" }}>
          {msg.sender === "astrologer" ? "Astrologer" : "User"}:
        </strong>
        {msg.text}
      </div>
    </div>
  ))
) : (
  <p>No chat messages available.</p>
)}

              </div>

             
              <div
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  background: "#fff",
                  padding: "10px",
                  overflowY: "auto",
                }}
              >
                <h5 className="text-danger mb-3">Violations & Actions</h5>

               
                {recommendedActions.length > 0 && (
                  <div className="mb-3">
                    <h6 className="text-primary">Recommended Actions</h6>
                    <ul style={{ paddingLeft: "20px" }}>
                      {recommendedActions.map((action, index) => (
                        <li key={index}>{action}</li>
                      ))}
                    </ul>
                  </div>
                )}

                
                {violationContent.length > 0 ? (
                  <div style={{ display: "grid", gap: "10px" }}>
                    {violationContent.map((item, index) => (
                      <div
                        key={index}
                        className="p-3 rounded shadow-sm"
                        style={{ backgroundColor: "#fffaf0" }}
                      >
                        <p className="mb-1">
                          <strong>Type:</strong> {item.Type} |{" "}
                          <strong>Severity:</strong>{" "}
                          <span
                            style={{
                              color:
                                item.Severity === "critical"
                                  ? "red"
                                  : item.Severity === "high"
                                  ? "#d97706"
                                  : "#666",
                              fontWeight: "bold",
                            }}
                          >
                            {item.Severity}
                          </span>
                        </p>
                        <p className="mb-1">
                          <strong>Detected Content:</strong>{" "}
                          <span style={{ color: "#000" }}>
                            {item.DetectedContent}
                          </span>
                        </p>
                        <p className="mb-1">
                          <strong>Reason:</strong> {item.Reason}
                        </p>
                        <p className="mb-1">
                          <strong>Sender:</strong>{" "}
                          <span style={{ textTransform: "capitalize" }}>
                            {item.Sender}
                          </span>
                        </p>
                        <p className="mb-1">
                          <strong>Suggested Action:</strong> {item.SuggestedAction}
                        </p>
                        <p className="mb-0">
                          <small style={{ color: "#666" }}>
                            Timestamp: {item.Timestamp}
                          </small>
                        </p>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p>No violations found.</p>
                )}
              </div>
            </div>
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowModal(false)}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>



      <div className="col-12 mt-2  main_card">
        {loading ? (
          <Loader />
        ) : (
          <DataTable
            dense
            data={chatData || []}
            columns={columns}
            selectableRowsHighlight
            pagination
            customStyles={customStyles}
            persistTableHead={true}
            noDataComponent={"There are no data to display"}
          />
        )}
      </div>
    </div>
  );
};
export default CallHistoryAnalysis;
